import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { CiLogout } from "react-icons/ci";

const LogoutButton = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogout = () => {
    //localStorage.removeItem("userId");
    localStorage.removeItem("token");
    navigate(`/`);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <a onClick={openModal}>
        <CiLogout /> Cerrar sesión
      </a>

      {/* Modal */}
      <Modal show={isModalOpen} onHide={closeModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>¿Estás seguro de que deseas cerrar sesión?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button variant="primary" onClick={handleLogout}>
            Sí, cerrar sesión
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            Cancelar
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LogoutButton;
